import axios from 'axios'

import { Axios } from 'axios'

export async function uploadFileToS3(api: Axios, file: File): Promise<string> {
  const s3PreSignedPost = await api
    .get(`/files/presignedPost?type=${encodeURIComponent(file.type)}`)
    .catch((error) => {
      throw new Error('Obtaining presigned S3 post failed.', error)
    })

  if (!s3PreSignedPost) {
    throw new Error('Did not got a presigned S3 post.')
  }

  // Preparing upload to s3
  const formData = new FormData()

  Object.entries(s3PreSignedPost.data.presignedPost.fields).forEach(([k, v]: [string, unknown]) => {
    const value = v as string
    formData.append(k, value)
  })

  formData.append('file', file)
  const s3ObjectKey = String(formData.get('key'))

  // S3 upload
  await axios.post(s3PreSignedPost.data.presignedPost.url, formData).catch((error) => {
    throw new Error('Upload to S3 failed.', error)
  })

  return s3ObjectKey
}
